<div class="leitor">
  <div class="leitor-barra">
    <div class="leitor-barra-de-opcoes">
      <div class="leitor-barra-de-opcoes-nome">
        <button class="opcao-leitor" (click)="fecharLeitorPdf.emit()"><i class="bx bx-chevron-left"></i></button>
        <p>{{ titulo || 'Documento' }}</p>
      </div>

      <div class="leitor-barra-de-opcoes-centro">
        <div class="opcoes-centro-paginas">
          <input class="pagina-atual" type="number" [(ngModel)]="paginaAtual" [disabled]="carregando || erroAoCarregar" />
          <span>/</span>
          <span>{{ totalDePaginasDoPdf }}</span>
        </div>
  
        <div class="opcoes-centro-zoom">
          <button 
            class="opcao-leitor" 
            [disabled]="carregando || erroAoCarregar"
            (click)="dimunirZoom()"
          >
            <i class="bx bx-minus"></i>
          </button>

          <input 
            class="zoom-atual" 
            type="text"
            [value]="zoomEmPorcentagem" 
            [disabled]="carregando || erroAoCarregar"
            (input)="mudarValorDoZoom($event)"
          />

          <button 
            class="opcao-leitor" 
            [disabled]="carregando || erroAoCarregar"
            (click)="aumentarZoom()"
          >
            <i class="bx bx-plus"></i></button>
        </div>
      </div>
      
      <div class="leitor-barra-de-opcoes-outras">
        <button 
          class="opcao-leitor"
          [disabled]="carregando || !source || erroAoCarregar" 
          (click)="baixarPdf()"
        >
          <i class='bx bx-down-arrow-alt'></i>
        </button>
      </div>
    </div>
  </div>
  <div class="leitor-conteudo">
    <pdf-viewer 
      [src]="source"
      [original-size]="false"
      [show-all]="true"
      [fit-to-page]="false"
      [zoom]="zoom"
      [zoom-scale]="'page-width'"
      [rotation]="0"
      [render-text]="true"
      [external-link-target]="'blank'"
      [autoresize]="true"
      [show-borders]="false"
      [(page)]="paginaAtual"
      style="width: 100%; height: 100%"
      (on-progress)="pdfCarregando($event)"
      (after-load-complete)="pdfCarregado($event)"
      (error)="carregando = false; erroAoCarregar = true"
    ></pdf-viewer>
    <div *ngIf="carregando" class="leitor-conteudo-loading">
      <i class="bx bx-loader-alt bx-spin"></i>
    </div>
    <div *ngIf="erroAoCarregar && !carregando" class="leitor-conteudo-erro">
      <img src="assets/imagens/ilustracoes/nao-encontrado.svg">
      <p>Ops! Infelizmente encontramos um erro na hora de carregar o pdf, verifique o arquivo.</p>
    </div>
  </div>
</div>